module.exports = __webpack_public_path__ + "static/media/garlic.646d0bb3.jpg";